import { render, staticRenderFns } from "./float-bar.vue?vue&type=template&id=610c264e&scoped=true"
import script from "./float-bar.vue?vue&type=script&lang=js"
export * from "./float-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c264e",
  null
  
)

export default component.exports